/* eslint-disable react/jsx-curly-newline */
import { useMemo } from 'react';
import * as React from 'react';

import RaceCard from '@/components/layouts/Race/RaceCard';
import GradeInfo from '@/components/layouts/Race/Singlerace/RaceInfo/GradeInfo';
import RaceProgramInfo, {
  PageType,
} from '@/components/layouts/Race/Singlerace/RaceProgramInfo';
import { RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { RaceInfoType } from '@/modelTypes';
import { raceSelector } from '@/selectors/race';

import { Headline } from '../../style';
import Button from './Partials/Button';
import {
  BackLink,
  BackLinkArea,
  BlackButtonLink,
  ButtonWrapper,
  DisabledButton,
  HeldDate,
  NoRaceText,
  RaceCardContent,
  RaceCardHeader,
  RaceCardInfoWrapper,
  RaceCardWrapper,
  RaceProgramInfoWrapper,
  Time,
  TimeWrapper,
} from './style';

interface RaceProgramTemplateProps {
  raceProgram: RaceProgram;
  racePrograms: RaceProgram[];
}

const RaceProgramTemplate: React.FC<RaceProgramTemplateProps> = ({
  raceProgram,
  racePrograms,
}) => {
  const dateString = useMemo(
    () => raceProgram.heldDate.format('YYYY年M月D日'),
    [raceProgram],
  );

  return (
    <>
      <Headline>出走表</Headline>
      <HeldDate>{dateString}</HeldDate>
      <RaceProgramInfoWrapper>
        <RaceProgramInfo
          raceProgram={raceProgram}
          racePrograms={racePrograms}
          pageType={PageType.RaceCard}
        />
      </RaceProgramInfoWrapper>
      {raceProgram.races.length > 0 ? (
        <RaceCardWrapper key={`race-${raceProgram.id}`}>
          {raceProgram.races.map(race => (
            <RaceCardContent key={`${race.raceEventName}-${race.id}`}>
              <RaceCardHeader>
                <RaceCardInfoWrapper>
                  <GradeInfo race={race} />
                  <TimeWrapper>
                    <Time>
                      発走時刻
                      <time>{race.startTime.format('H:mm')}</time>
                    </Time>
                    <Time>
                      締切時刻
                      <time>{race.orderDeadline.format('H:mm')}</time>
                    </Time>
                  </TimeWrapper>
                </RaceCardInfoWrapper>
                <Button raceProgram={raceProgram} race={race} />
              </RaceCardHeader>
              <RaceCard
                heldDate={raceProgram.heldDate}
                isFirstDay={raceProgram.heldDate.isSame(
                  raceProgram.heldFirstDate,
                  'day',
                )}
                entryRacers={race.entryRacers}
                raceInfoType={RaceInfoType.Score}
                scrollable
              />
              <ButtonWrapper>
                <BlackButtonLink
                  to={`/${
                    getVelodromeByCode(raceProgram.velodromeCode).romanName
                  }/race/${raceProgram.heldDate.format('YYYY-MM-DD')}/${
                    race.raceNum
                  }?infoType=${RaceInfoType.Basic}`}
                >
                  詳細
                </BlackButtonLink>
                {raceProgram.isCanceled || raceSelector(race).isCanceled ? (
                  <DisabledButton>オッズ</DisabledButton>
                ) : (
                  <BlackButtonLink
                    to={`/${
                      getVelodromeByCode(raceProgram.velodromeCode).romanName
                    }/race/${raceProgram.heldDate.format('YYYY-MM-DD')}/${
                      race.raceNum
                    }?infoType=${RaceInfoType.Odds}`}
                  >
                    オッズ
                  </BlackButtonLink>
                )}
              </ButtonWrapper>
            </RaceCardContent>
          ))}
        </RaceCardWrapper>
      ) : (
        <NoRaceText>開催情報がありません</NoRaceText>
      )}
      <BackLinkArea>
        <BackLink
          to={`/racecard?date=${raceProgram.heldDate.format('YYYY-MM-DD')}`}
        >
          出走表一覧
        </BackLink>
      </BackLinkArea>
    </>
  );
};

export default RaceProgramTemplate;
